import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';

import { ConfigState, ContextState, GetterClass } from '../../../models';

import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

export class CurrentInstanceGetter implements GetterClass {

  public static execute(state: ConfigState, getters: any, rootState: any, rootGetters: any): Instance {
    const context: ContextState = rootGetters[`${CONTEXT_CONSTS.moduleName}/${CONTEXT_CONSTS.getters.context}`];
    if (!!context.instanceId) {
      return state.instances.find((instanceConfig: Instance) => (instanceConfig.instanceId === context.instanceId));
    }
  }

}
